import React from 'react';
import { Shield } from 'lucide-react';
import { Section } from './Shared';
export const Guarantee = () => <Section className="max-w-3xl" data-id="element-103">
    <div className="glass-panel p-8 md:p-12 rounded-3xl text-center border-brand-rose/30 bg-white/80" data-id="element-104">
      <Shield className="w-14 h-14 md:w-16 md:h-16 text-brand-rose mx-auto mb-6" data-id="element-105" />
      <h2 className="text-xl md:text-3xl font-serif font-bold mb-4 text-brand-text" data-id="element-106">
        🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
      </h2>
      <p className="text-brand-text/80 mb-4 text-base md:text-lg" data-id="element-107">
        Abrís los tomos. Imprimís las planillas. Las usás en tu consultorio.
      </p>
      <p className="text-brand-text/80 mb-6 text-base md:text-lg" data-id="element-108">
        Si en 7 días no es lo que esperabas: devolución del 100% sin
        formularios, sin drama.
      </p>
      <p className="font-medium text-brand-rose text-sm md:text-base" data-id="element-109">
        Tasa de devoluciones: menos del 1%.
      </p>
    </div>
  </Section>;
export const Footer = () => <footer className="bg-brand-dark text-white/80 py-12 border-t border-brand-pink/20" data-id="element-110">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-111">
      <div className="mb-8" data-id="element-112">
        <h3 className="font-serif font-bold text-2xl text-white mb-2" data-id="element-113">
          🦶 REFLEXO-PRO™ by Lumen Akasha
        </h3>
        <p className="text-white/60" data-id="element-114">
          El sistema de gestión clínica N°1 para terapeutas en reflexología en
          Argentina.
        </p>
        <p className="text-white/60 mt-2" data-id="element-115">
          Porque atender pacientes con excelencia no debería costarte el orden
          de tu consultorio.
        </p>
      </div>

      <div className="flex flex-col md:flex-row justify-center items-center space-y-4 md:space-y-0 md:space-x-8 mb-12 text-sm" data-id="element-116">
        <a href="mailto:soportelumenakasha@gmail.com" className="hover:text-brand-rose transition-colors" data-id="element-117">
          📧 soportelumenakasha@gmail.com
        </a>
        <a href="https://instagram.com/lumen.akasha" className="hover:text-brand-rose transition-colors" data-id="element-118">
          📲 @lumen.akasha
        </a>
        <a href="https://www.lumenakasha.com" className="hover:text-brand-rose transition-colors" data-id="element-119">
          🌐 www.lumenakasha.com
        </a>
      </div>

      <div className="text-xs text-white/40 space-y-2" data-id="element-120">
        <p data-id="element-121">
          © Lumen Akasha™ 2024 — Todos los derechos reservados. Prohibida la
          reproducción y redistribución sin autorización expresa.
        </p>
        <p data-id="element-122">Ley 25.326 — Protección de Datos Personales — República Argentina</p>
      </div>

      <div className="mt-8" data-id="element-123">
        <p className="text-sm font-serif italic text-white/60" data-id="element-124">
          "El terapeuta que registra, recuerda. El que recuerda, transforma. El
          que transforma, crece." 🦶
        </p>
      </div>
    </div>
  </footer>;